import React from 'react';
import {Redirect, Route, Switch, Link} from 'react-router-dom';
import ScoreHistoryList from './ScoreHistoryList';

export default () => {
  const title = '顧客スコア変動履歴';

  return (
    <div className="p-8 bg-c-bg h-[calc(100vh-60px)] overflow-scroll">
      {/* Breadcrumb */}
      <ol className="inline-flex items-center mb-3 space-x-1 text-xs">
        <li>
          <div className="flex items-center">
            <Link to="/reports" className="ms-1 font-medium text-c-light">
              レポート
            </Link>
          </div>
        </li>
        <li aria-current="page">
          <div className="flex items-center">
            <svg
              className="rtl:rotate-180 w-2 h-2 mx-1 text-gray-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 6 10">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 9 4-4-4-4"
              />
            </svg>
            <span className="text-c-light font-bold">{title}</span>
          </div>
        </li>
      </ol>

      {/* Title */}
      <h1 className="my-4 text-xl font-bold">{title}</h1>

      {/* Content Container */}
      <div className="w-full rounded">
        <Switch>
          <Route path="/reports/score_history" component={ScoreHistoryList} />
          <Redirect to="/reports/score_history" />
        </Switch>
      </div>
    </div>
  );
};
